.wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.inputFieldWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.label {
  width: 50%;
}

.dateField {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}

.italic {
  font-style: italic;
  color: #bababa;
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  gap: 10px;
  margin-top: 10px;
}

.redirection,
.redirection:visited,
.redirection:active,
.redirection:hover {
  text-decoration: underline;
}
